module.exports = __webpack_public_path__ + "static/media/logo_chitkara.9b6a3216.png";